// Cookie utils
import { getSidCookieOptions } from './cookieUtils.js';

// Utils
import { debug } from './utils/debug.js';
import { COOKIE } from '@iva/utils';

// Constants
import { SID_COOKIE_NAME } from '../config.js';

const handleMissingSid = (sid) => {
  debug(`"handleSid" did not find SID cookie, creating new`);
  COOKIE.setCookie(SID_COOKIE_NAME, sid, getSidCookieOptions());
  if (window.sznIVA && window.sznIVA.IS) {
    window.sznIVA.IS.updateIdentities({ sid });
  }
  window.dispatchEvent(new CustomEvent('szn:linkdecoration:sid', { detail: sid }));
};

export { handleMissingSid };
